import React, { useState } from 'react';
import { ArrowRight, Building2, X, MapPin, Calendar, DollarSign, Users, CheckCircle, ChevronLeft, ChevronRight } from 'lucide-react';
import { Wrench, Truck, Home, Settings, Palette, Shield, FileText } from 'lucide-react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const PortfolioPage = () => {
  const [showQuoteModal, setShowQuoteModal] = useState(false);
  const [showProjectModal, setShowProjectModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [activeFilter, setActiveFilter] = useState('All');
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [quoteStatus, setQuoteStatus] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleQuoteSubmit = async (e) => {
      e.preventDefault();
      setQuoteStatus('sending');

      try {
        const response = await fetch('https://gusgroupltd.com/api/send-email.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ...formData,
            type: 'quote',
            website: '' // Honeypot field
          }),
        });

        const data = await response.json();

        if (response.ok && data.success) {
          setQuoteStatus('success');
          setFormData({ name: '', email: '', phone: '', service: '', message: '' });
          
          // Auto-close modal after 3 seconds
          setTimeout(() => {
            setShowQuoteModal(false);
            setQuoteStatus('');
          }, 3000);
        } else {
          setQuoteStatus('error');
          setTimeout(() => {
            setQuoteStatus('');
          }, 5000);
        }
      } catch (error) {
        console.error('Error:', error);
        setQuoteStatus('error');
        setTimeout(() => {
          setQuoteStatus('');
        }, 5000);
      }
  };

  const services = [
    {
      icon: <Wrench className="w-8 h-8" />,
      title: "Remodeling & Renovations",
      description: "Residential and commercial property upgrades."
    },
    {
      icon: <Truck className="w-8 h-8" />,
      title: "Road Construction & Civil Works",
      description: "Infrastructure and highway development."
    },
    {
      icon: <Home className="w-8 h-8" />,
      title: "Real Estate Services",
      description: "Realtor activities, property management, and brokerage."
    },
    {
      icon: <Settings className="w-8 h-8" />,
      title: "Furniture Supply & Design",
      description: "Custom and ready-made furniture solutions."
    },
    {
      icon: <Palette className="w-8 h-8" />,
      title: "Interior & Exterior Decoration",
      description: "Modern design, painting, and finishing services."
    },
    {
      icon: <Building2 className="w-8 h-8" />,
      title: "Building Development & Construction",
      description: "Full-scale property development projects."
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: "Importation & Exportation",
      description: "International trade facilitation."
    },
    {
      icon: <FileText className="w-8 h-8" />,
      title: "Sales & Purchase of Properties",
      description: "Land, residential, and commercial property transactions."
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: "Consultancy Services",
      description: "Advisory in real estate, construction, and business development."
    },
    {
      icon: <Settings className="w-8 h-8" />,
      title: "Facility Management & Maintenance",
      description: "Long-term upkeep of buildings and infrastructure."
    }
  ];
  const openProjectModal = (project) => {
    setSelectedProject(project);
    setCurrentImageIndex(0);
    setShowProjectModal(true);
  };

  const nextImage = () => {
    if (selectedProject) {
      setCurrentImageIndex((prev) => 
        prev === selectedProject.images.length - 1 ? 0 : prev + 1
      );
    }
  };

  const prevImage = () => {
    if (selectedProject) {
      setCurrentImageIndex((prev) => 
        prev === 0 ? selectedProject.images.length - 1 : prev - 1
      );
    }
  };

 

  const projects = [
    {
      id: 1,
      title: "Luxury Residential Complex",
      category: "Residential",
      location: "Airport Residential Area, Accra",
      year: "2023",
      client: "Prime Properties Ghana",
      budget: "GH₵ 8.5M",
      duration: "18 months",
      status: "Completed",
      coverImage: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&h=600&fit=crop",
      images: [
        "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1200&h=800&fit=crop"
      ],
      description: "A premium 50-unit residential complex featuring modern amenities, energy-efficient systems, and world-class finishes. The project includes a clubhouse, swimming pool, gym, and landscaped gardens.",
      challenges: [
        "Tight construction timeline",
        "Complex architectural design",
        "Integration of smart home systems"
      ],
      solutions: [
        "Implemented parallel construction phases",
        "Collaborated with international design consultants",
        "Partnered with leading smart home providers"
      ],
      features: [
        "50 luxury apartments",
        "Smart home automation",
        "Swimming pool & gym",
        "24/7 security system",
        "Underground parking",
        "Solar power backup"
      ]
    },
    {
      id: 2,
      title: "Corporate Office Tower",
      category: "Commercial",
      location: "Ridge, Accra",
      year: "2023",
      client: "Atlantic Business Group",
      budget: "GH₵ 12M",
      duration: "24 months",
      status: "Completed",
      coverImage: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=600&fit=crop",
      images: [
        "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=1200&h=800&fit=crop"
      ],
      description: "A state-of-the-art 10-story commercial office building with premium office spaces, conference facilities, and modern infrastructure. LEED certified for environmental sustainability.",
      challenges: [
        "Urban site constraints",
        "Environmental certification requirements",
        "High-rise structural complexity"
      ],
      solutions: [
        "Vertical construction methodology",
        "Green building materials and systems",
        "Advanced structural engineering"
      ],
      features: [
        "10 floors of office space",
        "LEED Gold certified",
        "High-speed elevators",
        "Central HVAC system",
        "Basement parking (100+ spaces)",
        "Rooftop terrace"
      ]
    },
    {
      id: 3,
      title: "Accra-Tema Highway Extension",
      category: "Infrastructure",
      location: "Accra-Tema Motorway",
      year: "2022",
      client: "Ghana Highway Authority",
      budget: "GH₵ 45M",
      duration: "36 months",
      status: "Completed",
      coverImage: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&h=600&fit=crop",
      images: [
        "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1587019158091-1a103c5dd17f?w=1200&h=800&fit=crop"
      ],
      description: "Major highway development project including 15km of new dual carriageway, 3 interchanges, drainage systems, and street lighting infrastructure.",
      challenges: [
        "Heavy traffic management",
        "Weather-related delays",
        "Complex drainage requirements"
      ],
      solutions: [
        "Night shift construction schedules",
        "Weather-adaptive construction methods",
        "Advanced drainage engineering"
      ],
      features: [
        "15km dual carriageway",
        "3 major interchanges",
        "Advanced drainage system",
        "LED street lighting",
        "Emergency lanes",
        "Pedestrian bridges"
      ]
    },
    {
      id: 4,
      title: "Achimota Mall Renovation",
      category: "Remodeling",
      location: "Achimota, Accra",
      year: "2024",
      client: "Achimota Retail Ltd",
      budget: "GH₵ 6.5M",
      duration: "12 months",
      status: "Completed",
      coverImage: "https://images.unsplash.com/photo-1555529902-5261145633bf?w=800&h=600&fit=crop",
      images: [
        "https://images.unsplash.com/photo-1555529902-5261145633bf?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1567958451986-2de427a4a0be?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1582719471137-c3967ffb1c42?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1519567241046-7f570eee3ce6?w=1200&h=800&fit=crop"
      ],
      description: "Complete renovation and modernization of a 35,000 sq ft shopping mall including facade upgrade, interior redesign, new retail units, and upgraded MEP systems.",
      challenges: [
        "Maintaining partial operations during renovation",
        "Structural modifications",
        "Limited construction hours"
      ],
      solutions: [
        "Phased renovation approach",
        "Specialized structural reinforcement",
        "Extended night shifts"
      ],
      features: [
        "Modern facade design",
        "50+ retail units",
        "Food court expansion",
        "New HVAC system",
        "LED lighting throughout",
        "Accessible facilities"
      ]
    },
    {
      id: 5,
      title: "East Legon Luxury Villas",
      category: "Residential",
      location: "East Legon, Accra",
      year: "2023",
      client: "Premium Homes Ghana",
      budget: "GH₵ 15M",
      duration: "20 months",
      status: "Completed",
      coverImage: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&h=600&fit=crop",
      images: [
        "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1600607687644-aac4c3eac7f4?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1613977257363-707ba9348227?w=1200&h=800&fit=crop"
      ],
      description: "Exclusive development of 8 luxury detached villas with contemporary architecture, premium finishes, and state-of-the-art amenities in one of Accra's most prestigious neighborhoods.",
      challenges: [
        "High-end finish requirements",
        "Custom architectural features",
        "Luxury material sourcing"
      ],
      solutions: [
        "International material procurement",
        "Specialized craftsmen teams",
        "Rigorous quality control"
      ],
      features: [
        "8 detached villas",
        "5-6 bedrooms each",
        "Private swimming pools",
        "Smart home systems",
        "Solar energy systems",
        "Landscaped gardens"
      ]
    },
    {
      id: 6,
      title: "Tema Industrial Warehouse",
      category: "Commercial",
      location: "Tema Industrial Area",
      year: "2022",
      client: "Logistics Hub Ghana",
      budget: "GH₵ 4.2M",
      duration: "10 months",
      status: "Completed",
      coverImage: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&h=600&fit=crop",
      images: [
        "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1553413077-190dd305871c?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1565514020179-026b92b84bb6?w=1200&h=800&fit=crop"
      ],
      description: "Modern 50,000 sq ft warehouse facility with advanced logistics infrastructure, climate control, and 24/7 security systems for distribution operations.",
      challenges: [
        "Large clear-span requirements",
        "Heavy load capacity floors",
        "Rapid construction timeline"
      ],
      solutions: [
        "Pre-engineered steel structure",
        "Industrial-grade concrete flooring",
        "Fast-track construction methods"
      ],
      features: [
        "50,000 sq ft storage space",
        "Climate-controlled sections",
        "Loading docks (10)",
        "Office complex",
        "Advanced security",
        "Fire suppression system"
      ]
    },
    {
      id: 7,
      title: "Kumasi Plaza Hotel",
      category: "Commercial",
      location: "Kumasi CBD",
      year: "2024",
      client: "Golden Tulip Hotels",
      budget: "GH₵ 25M",
      duration: "30 months",
      status: "Ongoing",
      coverImage: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=600&fit=crop",
      images: [
        "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=1200&h=800&fit=crop"
      ],
      description: "120-room luxury hotel development with conference facilities, restaurants, spa, and rooftop bar. Currently 75% complete with expected completion Q3 2024.",
      challenges: [
        "Complex MEP coordination",
        "High-end hospitality standards",
        "Ongoing operations timeline"
      ],
      solutions: [
        "BIM modeling for coordination",
        "International hospitality consultants",
        "Efficient project scheduling"
      ],
      features: [
        "120 luxury rooms",
        "Conference center",
        "3 restaurants & bars",
        "Spa & fitness center",
        "Rooftop pool",
        "Parking for 150 vehicles"
      ]
    },
    {
      id: 8,
      title: "Spintex Road Residential Estate",
      category: "Residential",
      location: "Spintex, Accra",
      year: "2023",
      client: "DevTrust Properties",
      budget: "GH₵ 18M",
      duration: "22 months",
      status: "Completed",
      coverImage: "https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=800&h=600&fit=crop",
      images: [
        "https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1605146769289-440113cc3d00?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1572120360610-d971b9d7767c?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=1200&h=800&fit=crop"
      ],
      description: "Gated community of 75 homes including apartments, townhouses, and semi-detached units with shared amenities and green spaces.",
      challenges: [
        "Mixed unit types coordination",
        "Infrastructure development",
        "Community amenities integration"
      ],
      solutions: [
        "Modular construction approach",
        "Comprehensive site planning",
        "Centralized amenity development"
      ],
      features: [
        "75 residential units",
        "Gated community",
        "Swimming pool",
        "Playground & parks",
        "24/7 security",
        "Underground utilities"
      ]
    },
    {
      id: 9,
      title: "Medical Center Renovation",
      category: "Remodeling",
      location: "Korle-Bu, Accra",
      year: "2022",
      client: "Korle-Bu Teaching Hospital",
      budget: "GH₵ 3.8M",
      duration: "8 months",
      status: "Completed",
      coverImage: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800&h=600&fit=crop",
      images: [
        "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1519494140681-8b17d830a3e9?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=1200&h=800&fit=crop",
        "https://images.unsplash.com/photo-1516549655169-df83a0774514?w=1200&h=800&fit=crop"
      ],
      description: "Complete renovation of a 20,000 sq ft medical facility including new patient rooms, upgraded operating theaters, and modern medical equipment installation.",
      challenges: [
        "Zero downtime requirement",
        "Medical-grade standards",
        "Infection control protocols"
      ],
      solutions: [
        "Rolling renovation phases",
        "Healthcare construction specialists",
        "Stringent hygiene protocols"
      ],
      features: [
        "40 patient rooms",
        "4 operating theaters",
        "ICU upgrade",
        "New HVAC system",
        "Medical gas systems",
        "Emergency power backup"
      ]
    }
  ];

  const categories = ['All', 'Residential', 'Commercial', 'Infrastructure', 'Remodeling'];

  const filteredProjects = activeFilter === 'All' 
    ? projects 
    : projects.filter(project => project.category === activeFilter);

  const stats = [
    { number: "500+", label: "Projects Completed" },
    { number: "GH₵ 500M+", label: "Total Project Value" },
    { number: "200+", label: "Happy Clients" },
    { number: "15+", label: "Years Experience" }
  ];

  return (
    <div className="bg-black text-white">
      <Navigation onQuoteClick={() => setShowQuoteModal(true)} />

      {/* Hero Section */}
      <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden pt-20">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=1920&h=1080&fit=crop')",
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/40"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
          <h2 className="text-yellow-400 text-sm uppercase tracking-widest mb-4 font-semibold">
            Our Portfolio
          </h2>
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Projects That
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">
              Define Excellence
            </span>
          </h1>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Explore our showcase of completed projects across Ghana
          </p>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-gradient-to-b from-black to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div 
                key={index}
                className="text-center"
              >
                <h3 className="text-4xl md:text-5xl font-bold text-yellow-400 mb-2">
                  {stat.number}
                </h3>
                <p className="text-gray-400">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-12 bg-gray-900 sticky top-20 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category, index) => (
              <button
                key={index}
                onClick={() => setActiveFilter(category)}
                className={`px-6 py-2 rounded-full font-semibold transition-all ${
                  activeFilter === category
                    ? 'bg-yellow-400 text-black'
                    : 'bg-black text-white hover:bg-gray-800 border border-yellow-400/20'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-24 bg-gradient-to-b from-gray-900 to-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProjects.map((project) => (
              <div 
                key={project.id}
                className="group bg-gradient-to-br from-gray-900 to-black rounded-2xl border border-yellow-400/20 hover:border-yellow-400/50 transition-all overflow-hidden cursor-pointer"
                onClick={() => openProjectModal(project)}
              >
                {/* Project Image */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={project.coverImage}
                    alt={project.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
                  
                  {/* Category Badge */}
                  <div className="absolute top-4 left-4">
                    <span className="bg-yellow-400 text-black px-3 py-1 rounded-full text-sm font-semibold">
                      {project.category}
                    </span>
                  </div>

                  {/* Status Badge */}
                  <div className="absolute top-4 right-4">
                    <span className={`px-3 py-1 rounded-full text-sm font-semibold ${
                      project.status === 'Completed' 
                        ? 'bg-green-500 text-white' 
                        : 'bg-blue-500 text-white'
                    }`}>
                      {project.status}
                    </span>
                  </div>

                  {/* Overlay Info */}
                  <div className="absolute bottom-4 left-4 right-4">
                    <h3 className="text-2xl font-bold text-white mb-2">
                      {project.title}
                    </h3>
                    <div className="flex items-center gap-2 text-gray-300 text-sm">
                      <MapPin className="w-4 h-4" />
                      <span>{project.location}</span>
                    </div>
                  </div>
                </div>

                {/* Project Details */}
                <div className="p-6">
                  <p className="text-gray-400 mb-4 line-clamp-2">
                    {project.description}
                  </p>

                  <div className="grid grid-cols-2 gap-4 mb-4 text-sm">
                    <div className="flex items-center gap-2 text-gray-300">
                      <Calendar className="w-4 h-4 text-yellow-400" />
                      <span>{project.year}</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-300">
                      <DollarSign className="w-4 h-4 text-yellow-400" />
                      <span>{project.budget}</span>
                    </div>
                  </div>

                  <button className="w-full bg-yellow-400/10 text-yellow-400 px-4 py-2 rounded-full font-semibold hover:bg-yellow-400 hover:text-black transition-all flex items-center justify-center gap-2 group-hover:bg-yellow-400 group-hover:text-black">
                    View Details
                    <ArrowRight className="w-4 h-4" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-r from-yellow-400 to-yellow-600 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-full h-full" style={{
            backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(0,0,0,.1) 35px, rgba(0,0,0,.1) 70px)'
          }}></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-black">
            Let's Build Your Vision Together
          </h2>
          <p className="text-xl text-black/80 mb-8 max-w-2xl mx-auto">
            Ready to start your own success story? Get in touch for a free consultation
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => setShowQuoteModal(true)}
              className="bg-black text-yellow-400 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-900 transition-all transform hover:scale-105 flex items-center gap-2 justify-center"
            >
              Get Free Quote
              <ArrowRight className="w-5 h-5" />
            </button>
            <a 
              href="tel:0592668258"
              className="border-2 border-black text-black px-8 py-4 rounded-full font-bold text-lg hover:bg-black hover:text-yellow-400 transition-all"
            >
              Call: 0592668258
            </a>
          </div>
        </div>
      </section>

      <Footer />

      {/* Project Detail Modal */}
      {showProjectModal && selectedProject && (
        <div className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto">
          <div className="bg-gradient-to-br from-gray-900 to-black border border-yellow-400/30 rounded-2xl max-w-6xl w-full my-8">
            <div className="p-8">
              {/* Modal Header */}
              <div className="flex justify-between items-start mb-6">
                <div>
                  <div className="flex items-center gap-3 mb-2">
                    <span className="bg-yellow-400 text-black px-3 py-1 rounded-full text-sm font-semibold">
                      {selectedProject.category}
                    </span>
                    <span className={`px-3 py-1 rounded-full text-sm font-semibold ${
                      selectedProject.status === 'Completed' 
                        ? 'bg-green-500 text-white' 
                        : 'bg-blue-500 text-white'
                    }`}>
                      {selectedProject.status}
                    </span>
                  </div>
                  <h2 className="text-4xl font-bold text-white mb-2">
                    {selectedProject.title}
                  </h2>
                  <div className="flex items-center gap-2 text-gray-400">
                    <MapPin className="w-4 h-4" />
                    <span>{selectedProject.location}</span>
                  </div>
                </div>
                <button
                  onClick={() => setShowProjectModal(false)}
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-all"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>

              {/* Image Gallery */}
              <div className="relative mb-8">
                <div className="aspect-video rounded-xl overflow-hidden">
                  <img
                    src={selectedProject.images[currentImageIndex]}
                    alt={`${selectedProject.title} ${currentImageIndex + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
                
                {/* Image Navigation */}
                {selectedProject.images.length > 1 && (
                  <>
                    <button
                      onClick={prevImage}
                      className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-black/50 hover:bg-yellow-400 text-white hover:text-black rounded-full flex items-center justify-center transition-all"
                    >
                      <ChevronLeft className="w-6 h-6" />
                    </button>
                    <button
                      onClick={nextImage}
                      className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-black/50 hover:bg-yellow-400 text-white hover:text-black rounded-full flex items-center justify-center transition-all"
                    >
                      <ChevronRight className="w-6 h-6" />
                    </button>
                    
                    {/* Image Counter */}
                    <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/70 px-4 py-2 rounded-full text-white text-sm">
                      {currentImageIndex + 1} / {selectedProject.images.length}
                    </div>
                  </>
                )}
              </div>

              {/* Thumbnail Strip */}
              {selectedProject.images.length > 1 && (
                <div className="flex gap-2 mb-8 overflow-x-auto pb-2">
                  {selectedProject.images.map((image, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentImageIndex(index)}
                      className={`flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2 transition-all ${
                        currentImageIndex === index
                          ? 'border-yellow-400'
                          : 'border-transparent hover:border-gray-600'
                      }`}
                    >
                      <img
                        src={image}
                        alt={`Thumbnail ${index + 1}`}
                        className="w-full h-full object-cover"
                      />
                    </button>
                  ))}
                </div>
              )}

              {/* Project Details Grid */}
              <div className="grid md:grid-cols-4 gap-6 mb-8">
                <div className="bg-black/50 p-4 rounded-xl border border-yellow-400/20">
                  <div className="flex items-center gap-2 mb-2">
                    <Calendar className="w-5 h-5 text-yellow-400" />
                    <span className="text-gray-400 text-sm">Year</span>
                  </div>
                  <p className="text-white font-bold text-lg">{selectedProject.year}</p>
                </div>

                <div className="bg-black/50 p-4 rounded-xl border border-yellow-400/20">
                  <div className="flex items-center gap-2 mb-2">
                    <DollarSign className="w-5 h-5 text-yellow-400" />
                    <span className="text-gray-400 text-sm">Budget</span>
                  </div>
                  <p className="text-white font-bold text-lg">{selectedProject.budget}</p>
                </div>

                <div className="bg-black/50 p-4 rounded-xl border border-yellow-400/20">
                  <div className="flex items-center gap-2 mb-2">
                    <Users className="w-5 h-5 text-yellow-400" />
                    <span className="text-gray-400 text-sm">Client</span>
                  </div>
                  <p className="text-white font-bold text-sm">{selectedProject.client}</p>
                </div>

                <div className="bg-black/50 p-4 rounded-xl border border-yellow-400/20">
                  <div className="flex items-center gap-2 mb-2">
                    <Building2 className="w-5 h-5 text-yellow-400" />
                    <span className="text-gray-400 text-sm">Duration</span>
                  </div>
                  <p className="text-white font-bold text-lg">{selectedProject.duration}</p>
                </div>
              </div>

              {/* Description */}
              <div className="mb-8">
                <h3 className="text-2xl font-bold text-yellow-400 mb-4">Project Overview</h3>
                <p className="text-gray-300 text-lg leading-relaxed">
                  {selectedProject.description}
                </p>
              </div>

              {/* Features */}
              <div className="mb-8">
                <h3 className="text-2xl font-bold text-yellow-400 mb-4">Key Features</h3>
                <div className="grid md:grid-cols-2 gap-3">
                  {selectedProject.features.map((feature, index) => (
                    <div key={index} className="flex items-start gap-2">
                      <CheckCircle className="w-5 h-5 text-yellow-400 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-300">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Challenges & Solutions */}
              <div className="grid md:grid-cols-2 gap-8 mb-8">
                <div>
                  <h3 className="text-2xl font-bold text-yellow-400 mb-4">Challenges</h3>
                  <ul className="space-y-3">
                    {selectedProject.challenges.map((challenge, index) => (
                      <li key={index} className="flex items-start gap-2">
                        <div className="w-2 h-2 bg-yellow-400 rounded-full mt-2 flex-shrink-0"></div>
                        <span className="text-gray-300">{challenge}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div>
                  <h3 className="text-2xl font-bold text-yellow-400 mb-4">Solutions</h3>
                  <ul className="space-y-3">
                    {selectedProject.solutions.map((solution, index) => (
                      <li key={index} className="flex items-start gap-2">
                        <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-300">{solution}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* CTA */}
              <div className="bg-gradient-to-r from-yellow-400/10 to-yellow-600/10 border border-yellow-400/30 rounded-xl p-6 text-center">
                <h4 className="text-2xl font-bold text-white mb-2">
                  Interested in a Similar Project?
                </h4>
                <p className="text-gray-400 mb-6">
                  Let's discuss how we can bring your vision to life
                </p>
                <button 
                  onClick={() => {
                    setShowProjectModal(false);
                    setShowQuoteModal(true);
                  }}
                  className="bg-yellow-400 text-black px-8 py-3 rounded-full font-bold hover:bg-yellow-500 transition-all transform hover:scale-105 flex items-center gap-2 mx-auto"
                >
                  Request a Quote
                  <ArrowRight className="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Quote Modal */}
      {showQuoteModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-gradient-to-br from-gray-900 to-black border border-yellow-400/30 rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-8">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-3xl font-bold text-white">Request a Quote</h3>
                <button
                  onClick={() => setShowQuoteModal(false)}
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-all"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>

              {/* Status Messages */}
              {quoteStatus === 'sending' && (
                <div className="mb-6 bg-blue-500/10 border border-blue-500/50 rounded-xl p-4 flex items-start gap-3">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
                  <div>
                    <h4 className="text-blue-500 font-bold mb-1">Sending Request...</h4>
                    <p className="text-gray-300 text-sm">Please wait while we process your quote request.</p>
                  </div>
                </div>
              )}

              {quoteStatus === 'success' && (
                <div className="mb-6 bg-green-500/10 border border-green-500/50 rounded-xl p-4 flex items-start gap-3">
                  <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" />
                  <div>
                    <h4 className="text-green-500 font-bold mb-1">Quote Request Sent Successfully!</h4>
                    <p className="text-gray-300 text-sm">Thank you! We'll contact you soon with your quote. This window will close automatically.</p>
                  </div>
                </div>
              )}

              {quoteStatus === 'error' && (
                <div className="mb-6 bg-red-500/10 border border-red-500/50 rounded-xl p-4 flex items-start gap-3">
                  <X className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" />
                  <div>
                    <h4 className="text-red-500 font-bold mb-1">Failed to Send Request</h4>
                    <p className="text-gray-300 text-sm">Please try again or call us directly at 0592668258</p>
                  </div>
                </div>
              )}

              <form onSubmit={handleQuoteSubmit} className="space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-semibold text-gray-300 mb-2">Full Name *</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      disabled={quoteStatus === 'sending'}
                      className="w-full px-4 py-3 bg-black border border-gray-700 rounded-lg text-white focus:border-yellow-400 focus:outline-none transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                      placeholder="John Doe"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-300 mb-2">Email *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      disabled={quoteStatus === 'sending'}
                      className="w-full px-4 py-3 bg-black border border-gray-700 rounded-lg text-white focus:border-yellow-400 focus:outline-none transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                      placeholder="john@example.com"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-300 mb-2">Phone *</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    disabled={quoteStatus === 'sending'}
                    className="w-full px-4 py-3 bg-black border border-gray-700 rounded-lg text-white focus:border-yellow-400 focus:outline-none transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                    placeholder="0501234567"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-300 mb-2">Service Required *</label>
                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleInputChange}
                    required
                    disabled={quoteStatus === 'sending'}
                    className="w-full px-4 py-3 bg-black border border-gray-700 rounded-lg text-white focus:border-yellow-400 focus:outline-none transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <option value="">Select a service</option>
                    {services.map((service, i) => (
                      <option key={i} value={service.title}>{service.title}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-300 mb-2">Project Details *</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    disabled={quoteStatus === 'sending'}
                    rows="5"
                    className="w-full px-4 py-3 bg-black border border-gray-700 rounded-lg text-white focus:border-yellow-400 focus:outline-none transition-all resize-none disabled:opacity-50 disabled:cursor-not-allowed"
                    placeholder="Tell us about your project requirements, timeline, budget, etc."
                  ></textarea>
                </div>

                <div className="flex gap-4">
                  <button
                    type="button"
                    onClick={() => {
                      setShowQuoteModal(false);
                      setQuoteStatus('');
                    }}
                    disabled={quoteStatus === 'sending'}
                    className="flex-1 border-2 border-gray-700 text-white px-8 py-4 rounded-full font-bold hover:border-yellow-400 hover:text-yellow-400 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={quoteStatus === 'sending' || quoteStatus === 'success'}
                    className="flex-1 bg-yellow-400 text-black px-8 py-4 rounded-full font-bold hover:bg-yellow-500 transition-all transform hover:scale-105 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                  >
                    {quoteStatus === 'sending' ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-black"></div>
                        Sending...
                      </>
                    ) : (
                      <>
                        Submit Request
                        <ArrowRight className="w-5 h-5" />
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* WhatsApp Floating Button */}
      
       <a href="https://wa.me/233592668258?text=Hello%20GUS%20Group,%20I'm%20interested%20in%20your%20services"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 w-16 h-16 bg-green-500 rounded-full flex items-center justify-center shadow-2xl hover:bg-green-600 transition-all transform hover:scale-110 z-40"
      >
        <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>
      </a>
    </div>
  );
};

export default PortfolioPage;